/**
 * Canonical Privacy Policy copy.
 * Imported by `PrivacyPolicy.jsx` and `signupLegalDocuments.js` (Sign-up modal).
 */
export const PRIVACY_POLICY_SECTIONS = [
  {
    title: "1. Information We Collect",
    body: "AlphaSniper Trading collects limited information needed to provide and improve our services. This may include your email address, name, Telegram username, payment metadata from third-party processors, and usage data related to how you interact with our website and onboarding flows.",
  },
  {
    title: "2. How We Use Your Information",
    body: "We use collected data to deliver service access, process onboarding requests, send important updates, respond to support inquiries, improve strategy operations, and protect against abuse, fraud, or unauthorized access.",
  },
  {
    title: "3. Information Sharing",
    body: "We do not sell your personal data. We may share limited information with trusted providers only when necessary to operate the service (such as payment infrastructure, communication platforms, analytics, and hosting), to comply with law, or to protect legal rights and platform security.",
  },
  {
    title: "4. Data Security",
    body: "We apply reasonable technical and organizational safeguards, including encrypted transport, controlled access, and operational security practices. However, no internet-based system can be guaranteed as fully secure.",
  },
  {
    title: "5. Cookies and Tracking",
    body: "Our website may use cookies and similar technologies to remember preferences, analyze traffic, and improve user experience. You can control cookies through your browser settings, though some site features may be affected if cookies are disabled.",
  },
  {
    title: "6. Your Rights",
    body: "Depending on your jurisdiction, you may have rights to access, correct, delete, or restrict processing of your data, and to withdraw consent where applicable. You may also request data portability or object to certain processing activities.",
  },
  {
    title: "7. Data Retention",
    body: "We retain data only for as long as needed for service delivery, legal compliance, dispute handling, and legitimate business operations. Retention periods may vary depending on account status and applicable laws.",
  },
  {
    title: "8. Third-Party Services",
    body: "Our site may contain links or integrations with third-party platforms (for example payment providers, messaging tools, or broker-related services). Their privacy practices are governed by their own policies, and we encourage users to review them directly. If you onboard with a designated broker partner, that broker processes account-related data under its own policies; certain promotional guarantees (such as a first-month refund review) may require use of those partner channels, as explained in our Refund Policy.",
  },
  {
    title: "9. Minors",
    body: "Our services are intended for adults. We do not knowingly collect personal information from individuals under 18. If we become aware that such data was provided, we will take steps to remove it.",
  },
  {
    title: "10. International Transfers",
    body: "Because our tools and providers may operate globally, data may be processed across different jurisdictions. Where required, we implement appropriate safeguards for cross-border data handling.",
  },
  {
    title: "11. Policy Updates",
    body: "We may update this Privacy Policy from time to time. Any material changes will be reflected on this page with an updated effective date. Continued use of the service after updates constitutes acceptance of the revised policy.",
  },
  {
    title: "12. Contact",
    body: "For privacy-related requests or questions, please contact AlphaSniper Trading through our official support channels (website contact link or official Telegram contact listed on our site).",
  },
];
